import React from 'react';

import {
  CheckAvailabilityCarouselMessage,
  CustomMessage,
} from '@tomis-tech/types';
import CheckAvailabilityCarousel from './CheckAvailabilityCarousel';

export interface ChatCustomMessageProps {
  message: CustomMessage;
}

const ChatCustomMessage: React.FC<ChatCustomMessageProps> = ({ message }) => {
  if (message.customType === 'checkAvailability') {
    return (
      <CheckAvailabilityCarousel
        message={message as CheckAvailabilityCarouselMessage}
      />
    );
  } else {
    return <div>this is a custom message</div>;
  }
};

export default ChatCustomMessage;
